import './styles.scss';
import * as $ from 'jquery';

import Modernizr from '../../js/libs/modernizr-custom';

export default function initNavDropdowns() {
  $('.dropdown-toggle').on('mouseenter', function () {
    if (!Modernizr.touchevents) {
      clearTimeout(window.dropdownTimer);
      if (!$(this).parent().hasClass('show')) {
        $(this).trigger('click');
      }
    }
  });

  $('.dropdown-menu').on('mouseenter', function () {
    if (!Modernizr.touchevents) {
      clearTimeout(window.dropdownTimer);
    }
  });

  $('.btn-group, .dropdown').on('mouseleave', function () {
    if (!Modernizr.touchevents) {
      if ($(this).hasClass('show')) {
        window.dropdownElement = $(this);
        window.dropdownTimer = setTimeout(() => {
          window.dropdownElement
            // $(this)
            .children('.dropdown-toggle')
            .first()
            .trigger('click')
            .trigger('blur');
        }, 1000);
        // $(this)
        //   .children('.dropdown-toggle')
        //   .first()
        //   .trigger('click')
        //   .trigger('blur');
      }
    }
  });
}
